module.exports = __webpack_public_path__ + "static/media/logoSmall.e0d1ee2d.svg";